import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';

export class DemandeFermetureValidationOrder {
	
	accesId!: number;
	dateValidation!: LocalDateTime | undefined;
	
	constructor(id: number, dateValidation: LocalDateTime | undefined) {
		this.accesId = id;
		this.dateValidation = dateValidation;
	}
}